/**
 * Surfaces a failed request's status to ErrorHandler via history state without
 * touching the query string. Pages that keep their selection in the URL (useUrlState)
 * would otherwise lose it and re-default on every timeout or error.
 * @param {import('history').History} history react-router history
 * @param {number | undefined} code HTTP status (undefined on network error/timeout)
 */
export const replaceWithErrorStatus = (history, code) => {
  history.replace({
    pathname: history.location.pathname,
    search: history.location.search
  }, {
    errorStatusCode: code
  });
}
